<template>
  <div class="menue">
    <div class="out-mitarbeiter">
      <div v-for="m in mitarbeiter" :key="m.id" class="mitarbeiter">
        <h1 class="h11">{{ m.firstName }} {{ m.lastName }} - {{ m.role }}</h1>
        <button @click="deleteMitarbeiter(m.id)" class="delete-btn">Löschen</button>
      </div>
    </div>
    <button @click="showPopup = true" class="add-btn">Mitarbeiter hinzufügen</button>

    <!-- Popup für das Hinzufügen von Mitarbeitern -->
    <div v-if="showPopup" class="popup">
      <div class="popup-content">
        <h2>Mitarbeiter hinzufügen</h2>
        <input v-model="newMitarbeiter.firstName" placeholder="Vorname" class="input-field" />
        <input v-model="newMitarbeiter.lastName" placeholder="Nachname" class="input-field" />
        <input v-model="newMitarbeiter.username" placeholder="Nutzername" class="input-field" />
        <input type="password" v-model="newMitarbeiter.password" placeholder="Passwort" class="input-field" />
        <select v-model="newMitarbeiter.role" class="role-select">
          <option value="Montage">Montage</option>
          <option value="Buero">Büro</option>
        </select>
        <div class="button-group">
          <button @click="addMitarbeiter" class="btn">Hinzufügen</button>
          <button @click="showPopup = false" class="close-btn">Schließen</button>
        </div>
      </div>
    </div>
  </div>
</template>



<script>    
import { ref, onMounted } from "vue";
import axios from "axios";
import { keycloak, initKeycloak } from '../keycloak';

export default {
  setup() {
    const mitarbeiter = ref([]);
    const newMitarbeiter = ref({ 
      firstName: '', 
      lastName: '', 
      username: '', 
      password: '',  // Neues Passwortfeld
      role: 'Montage' 
    });
    const showPopup = ref(false);

    axios.interceptors.request.use(config => {
      config.headers['Authorization'] = `Bearer ${keycloak.token}`;
      return config;
    }, error => {
      return Promise.reject(error);
    });

    const loadMitarbeiter = async () => {
      try {
        const response = await axios.get("/api/workers");
        mitarbeiter.value = response.data;
      } catch (error) {
        console.error("Fehler beim Laden der Mitarbeiter:", error.response?.data || error);
      }
    };



    const deleteMitarbeiter = async (id) => {
      try {
        await axios.post(`/api/workers/${id}/delete`);
        mitarbeiter.value = mitarbeiter.value.filter(m => m.id !== id);
      } catch (error) {
        console.error("Fehler beim Löschen des Mitarbeiters:", error.response?.data || error);
      }
    };

    const addMitarbeiter = async () => {
      try {
        const response = await axios.post("/api/workers", newMitarbeiter.value);
        mitarbeiter.value.push(response.data);
        newMitarbeiter.value = { firstName: '', lastName: '', username: '', password: '', role: 'Montage' };
        showPopup.value = false; // Popup schließen
      } catch (error) {
        console.error("Fehler beim Hinzufügen des Mitarbeiters:", error.response?.data || error);
      }
    };

    onMounted(() => {
      loadMitarbeiter();
    });

    return { mitarbeiter, newMitarbeiter, deleteMitarbeiter, addMitarbeiter, showPopup };
  },
};
</script>

<style scoped>
.menue {
  background-color: #1f2937;
  padding: 20px;
  border-radius: 5px;
  width: 60vw;
}

.mitarbeiter {
  display: flex;
  align-items: center;
  justify-content: space-between; /* Gleichmäßige Verteilung */
  padding: 10px;
  background-color: #2d3748; /* Etwas dunklerer Hintergrund für die Zeilen */
  margin-bottom: 10px; /* Abstand zwischen den Zeilen */
  border-radius: 8px; /* Abgerundete Ecken */
}

.role-select {
/* Abstand zum Namen */
margin-bottom: 10px;
  background-color: rgba(255, 255, 255, 0.1); /* Transparenter Hintergrund */
  border: 1px solid #374151; /* Border für bessere Sichtbarkeit */
  border-radius: 5px; /* Abgerundete Ecken */
  color: #f3f4f6; /* Textfarbe */
  padding: 10px; /* Innenabstand */
  transition: background-color 0.3s ease; /* Sanfte Übergänge */
}

.role-select:hover {
  background-color: rgba(255, 255, 255, 0.2); /* Heller bei Hover */
}

.delete-btn {
  background-color: #DC2626;
  padding: 10px;
  outline: none;
  border: none;
  border-radius: 5px;
  color: white; /* Textfarbe für den Button */
  cursor: pointer; /* Hand-Cursor bei Hover */
}

.add-btn {
  background-color: #4F46E5; /* Hintergrundfarbe für den "Mitarbeiter hinzufügen"-Button */
  color: white; /* Textfarbe */
  padding: 10px 20px; /* Innenabstand */
  border: none;
  border-radius: 5px; /* Abgerundete Ecken */
  cursor: pointer;
  margin-top: 20px; /* Abstand nach oben */
}

.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7); /* Dunkler Hintergrund mit Transparenz */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* Über anderen Elementen */
}

.popup-content {
  background-color: #2d3748; /* Hintergrundfarbe des Popups */
  padding: 20px;
  border-radius: 10px; /* Abgerundete Ecken */
  width: 400px; /* Breite des Popups */
}

.input-field {
  margin-bottom: 10px; /* Abstand zwischen den Feldern */
  padding: 10px;
  width: 99%; /* Breite für die Eingabefelder */
  border: 1px solid #374151; /* Border für die Eingabefelder */
  border-radius: 5px; /* Abgerundete Ecken */
  background-color: rgba(255, 255, 255, 0.1); /* Transparenter Hintergrund */
  color: #f3f4f6; /* Textfarbe */
}

.button-group {
  display: flex;
  justify-content: space-between; /* Abstand zwischen den Buttons */
}

.close-btn {
  background-color: #DC2626; /* Hintergrundfarbe für den Schließen-Button */
  color: white;
  border: none;
  border-radius: 5px; /* Abgerundete Ecken */
  padding: 10px;
  cursor: pointer;
}

.btn {
  background-color: #4F46E5; /* Hintergrundfarbe für den Hinzufügen-Button */
  color: white;
  border: none;
  border-radius: 5px; /* Abgerundete Ecken */
  padding: 10px;
  cursor: pointer;
}
</style>
